import React from "react";
import { useTranslation } from "react-i18next";

import RangeFilters from "./RangeFilters";

function AgeFilters(props) {
  const { t } = useTranslation();

  return (
    <RangeFilters
      title={t("opportunity:candidates.ageFilters.title")}
      filterName="age"
      min={16}
      max={65}
      marks={{
        16: "16",
        28: "28",
        40: "40",
        52: "52",
        65: "+65"
      }}
      {...props}
    />
  );
}

export default AgeFilters;
